<template>
  <div :class="classes">
    <pt-page-title :title="posterData.name"></pt-page-title>
    <div v-if="posterData">
      <pt-sub-title title="海报信息"></pt-sub-title>
      <pt-form-item class="special" label="海报名称：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="海报图：" :labelWidth="labelWidth" v-if="posterData.imageUrl" :lineHeight="lineHeight">
        <pt-img :src="posterData.imageUrl" :isPublic="true" class="quaImages"></pt-img>
      </pt-form-item>
      <pt-form-item class="special" label="海报类型：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.poster_type}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="适用商品：" :labelWidth="labelWidth" :lineHeight="lineHeight" v-if="posterData.type==='GOODS'">
        <!-- <span>{{posterData.goodsName}}</span> -->
        <good-table :goodsData="posterData.goodsData"></good-table>
      </pt-form-item>
      <pt-form-item class="special" label="海报主题色：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.themeColor}}</span>
        <!-- <el-color-picker :value="posterData.themeColor" :disabled="true"></el-color-picker> -->
      </pt-form-item>
      <pt-form-item class="special" label="二维码右侧文字：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span v-html="posterData.rightText"></span>
      </pt-form-item>
      <pt-form-item class="special" label="是否在工具中心展示：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.visibleInTools ? '是' :'否'}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="海报状态：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{posterData.status_copy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="驳回原因：" :labelWidth="labelWidth" :lineHeight="lineHeight" v-if="posterData.status ==='DECLINED'">
        <span>{{posterData.reason}}</span>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(posterData)">编辑</el-button>
    </div>
  </div>
</template>

<script>
import goodTable from '../pt-poster-form/good-table'
// 组件class前缀
const prefixCls = 'pt-poster-detail'

export default {
  name: 'pt-poster-detail',
  props: {
    poster: {
      type: Object,
      default: () => {
        return {
          base: {}
        }
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: { goodTable },
  watch: {
    poster (val) {
      this.posterData = val
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '26',
      posterData: this.poster
    }
  },
  methods: {
    goEdit (data) {
      this.$router.push(`/post-manage/poster-form/true/${data.id}`)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';

/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-poster-detail{
  .special >span{
    color:@mainColor;
  }
  .quaImages{
    width: 170px;
    height: 225px;
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
